//=====================================================
//  ページング共通関数
//=====================================================

//-----------------------------------------------------
//  ページ番号取得
//-----------------------------------------------------
export function pageNoCurrent(){
    var url = new URL(window.location.href);
    var pageNo = url.searchParams.get("pageNo")
    if (pageNo != null) {
        return parseInt(pageNo)
    }
    return 1
}

//-----------------------------------------------------
//  ページ番号が最大か判断
//  maxPageNo: ページの最大値
//-----------------------------------------------------
export function pageMaxCurrent(maxPageNo: number){
    var url = new URL(window.location.href);
    var pageNo = url.searchParams.get("pageNo")
    var pageMaxNo = url.searchParams.get("maxPage")
    if (pageNo !== null || pageMaxNo !== null) {
        if (Number(pageMaxNo) > 1 && Number(pageMaxNo) !== Number(pageNo)) {
            return true
        }
        return false
    }
    if (maxPageNo > 1) {
        return true
    }
    return false
}

//-----------------------------------------------------
//  全てのページ数をカウントする
//  val: ページの最大値
//-----------------------------------------------------
export function allPage(val: number){
    const countPage = [];
    for (let index = 0; index <= val; index++) {
        countPage[index] = (index+1)
    }
    return countPage
}

//-----------------------------------------------------
//  選択されたページを判断
//  selectFlag: 選択ページ番号
//-----------------------------------------------------
export function selectPage(selectFlag: number){
    var url = window.location.href
    var result = 0;
    if (url.match(/pageNo=/)) {
        var pageNoStart = url.indexOf('pageNo=')
        var pageNoEnd = url.indexOf('maxPage=')
        result = Number(url.substring((pageNoStart + 7), (pageNoEnd - 1)))
    } else {
        result = 1;
    }
    if (result === selectFlag) {
        return true
    } else {
        return false
    }
}

//----------------------------------------------------
// ページ送り処理
// v: ボタン識別番号（＜:0 ＞:1）
//-----------------------------------------------------
export function pageSend(v: number){
    var url = window.location.href
    var result = 1;
    var maxResult = 1;

    // ＞ 押下時の処理
    var pageNoStart = url.indexOf('pageNo=')
    var pageNoEnd = url.indexOf('maxPage=')
    if (url.match(/pageNo=/)) {
        result = Number(url.substring((pageNoStart + 7), (pageNoEnd - 1)))
        maxResult = Number(url.substr(pageNoEnd + 8))
    }
    if (v === 1) {
        if (url.match(/pageNo=/)) {
            if (result < maxResult) {
                result++
            }
        } else {
            result++
        }

    // ＜ 押下時の処理
    } else if (v === 0) {
        if (url.match(/pageNo=/)) {
            if (result > 1){
                result--
            } else {
                result = 1
            }

        } else {
            result = 1;
        }
    }
    return result   
}